import React, { useState, useContext, useEffect } from 'react';
import Alert from 'react-s-alert';
import { Link } from 'react-router-dom';
import moment from 'moment';

// import contexts
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// import services
import ProviderService from '../../services/ProviderService';

// local imports
import Message from '../general/Message';
import GeneralNavbar from '../general/GeneralNavbar';
import Footer from '../general/Footer';


const ProviderSignUpStep3 = props => {

    // contexts
    const { theme, colors, fontFamily, fontSize, fontWeight } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // states
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState();
    const [provider, setProvider] = useState({
        languages: [],
        specialities: [],
        degrees: [],
    });
    const [requirementsList, setRequirementsList] = useState([false, false, false, false, false]);

    // useEffects
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (message && message.msgError) {
            window.scrollTo(0, 0);
        }
    }, [message]);

    useEffect(() => {
        try {
            if (props.location.state) {
                setProvider(props.location.state.provider);
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // GeneralService.logError('at Client MakePayment useEffect2', 'Error in try catch block', err.stack);
        }
    }, [props.location.state]);

    const goBack = () => {
        props.history.push({
            pathname: '/counsellor/signup-step1',
            state: {
                provider: provider,
            }
        });
    }

    const handleSubmit = e => {
        e.preventDefault();
        try {
            if (requirementsList[0] && requirementsList[1] && requirementsList[2] && requirementsList[3] && requirementsList[4]) {
                setIsLoading(true);
                ProviderService.signup(provider)
                    .then(data => {
                        // console.log('data', data);
                        setUser({ ...user, selectedRole: data.user.selectedRole, roles: data.user.roles, username: data.user.username, profileImage: data.user.profileImage });
                        Alert.info(data.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        props.history.push('/counsellor/sessions');
                        setIsLoading(false);
                    })
                    .catch(error => {
                        console.log('error', error);
                        Alert.error(error.message.msgBody, {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        setIsLoading(false);
                    });
            } else {
                setMessage({ msgError: true, msgBody: "You must need to follow all requirements" });
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            // setIsLoading2(false);
            // GeneralService.logError('at Provider ProviderProfile handleSubmit', 'Error in try catch block', err.stack);
        }
    }

    // function's return
    return (
        <div>
            <GeneralNavbar history={props.history} />
            <div className='my-4 px-2'>
                <h1 id="counsellor-signup-set2-heanding" style={theme.headingMedium}>Counsellor Signup</h1>
                <div className='row'>

                    <div className='col-md-3 col-12' style={{ borderRight: "solid 1px", borderColor: "#C0C0C0" }}>
                        <ol className='px-3'>
                            <li id="li-1-set2" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm }}>Fill in your Information</li>
                            <li id="li-2-set2" className='mt-2' style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md_sm, fontWeight: fontWeight.semiBold }}>Review and Submit</li>
                        </ol>
                    </div>

                    <div className='col-md-9 col-12'>
                        <h2 id="form-label-set2" style={{ fontFamily: fontFamily.primary, fontSize: fontSize.md, fontWeight: fontWeight.semiBold }}>Review and Submit</h2>
                        <hr style={{ color: "#C0C0C0", borderWidth: "2px" }} />

                        {message ? <div className='my-3'><Message message={message} /></div> : null}

                        <div style={{ overflowWrap: 'anywhere' }}>
                            <h3 style={{ fontFamily: fontFamily.primary, fontSize: fontSize.lg, fontWeight: fontWeight.medium }}>Your Information</h3>

                            <table className='mt-3' style={{ fontFamily: fontFamily.primary }}>

                                <colgroup>
                                    <col span="1" style={{ width: "40%" }} />
                                    <col span="1" style={{ width: "60%" }} />
                                </colgroup>

                                <tbody>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Title
                                        </td>
                                        <td id="title-set2">
                                            <span></span>{provider.title}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            First Name
                                        </td>
                                        <td id='firstname-set2'>
                                            {provider.firstName}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Last Name
                                        </td>
                                        <td id='lastname-set2'>
                                            {provider.lastName}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Email
                                        </td>
                                        <td id='email-set2'>
                                            {provider.email}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Gender
                                        </td>
                                        <td id="gender-set2">
                                            {provider.gender}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            BirthDate
                                        </td>
                                        <td id="birthDate-set2">
                                            {moment(provider.birthDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Address line 1
                                        </td>
                                        <td id='address1-set2'>
                                            {provider.address1}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Address line 2
                                        </td>
                                        <td id='address2-set2'>
                                            {provider.address2}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            City
                                        </td>
                                        <td id="state-set2">
                                            {provider.city}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            State
                                        </td>
                                        <td id="city-set2">
                                            {provider.state}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Pincode
                                        </td>
                                        <td id="pincode-set2">
                                            {provider.pincode}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Country
                                        </td>
                                        <td id="country-set2">
                                            India
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Specialities
                                        </td>
                                        <td id="speciality-set2">
                                            {provider.specialities.join(', ')}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Degrees
                                        </td>
                                        <td id="degree-set2">
                                            {provider.degrees.join(', ')}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Languages
                                        </td>
                                        <td id="language-set2">
                                            {provider.languages.join(', ')}
                                        </td>
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: fontWeight.medium, verticalAlign: 'top' }}>
                                            Description
                                        </td>
                                        <td id="desc-set2">
                                            {provider.description}
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>


                        <div className='mt-3'>
                            <h3 style={{ fontFamily: fontFamily.primary, fontSize: fontSize.lg, fontWeight: fontWeight.medium }}>Mandatory Requirements</h3>

                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[0]} id="cb1" onChange={(e) => setRequirementsList({ ...requirementsList, 0: e.target.checked })} />
                                <label className="form-check-label ml-2" htmlFor="cb1" style={{ cursor: "pointer" }}> I am a resident of India</label>
                            </div>
                            <div className="form-check">
                                <input name="mod2" className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[1]} id="cb2" onChange={(e) => setRequirementsList({ ...requirementsList, 1: e.target.checked })} />
                                <label className="form-check-label ml-2" htmlFor="cb2" style={{ cursor: "pointer" }}> I have at least a Masters Degree in psychology or related field</label>
                            </div>
                            <div className="form-check">
                                <input name="mod3" className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[2]} id="cb3" onChange={(e) => setRequirementsList({ ...requirementsList, 2: e.target.checked })} />
                                <label className="form-check-label ml-2" htmlFor="cb3" style={{ cursor: "pointer" }}> I have access to a reliable Internet connection to provide online services</label>
                            </div>
                            <div className="form-check">
                                <input name="mod4" className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[3]} id="cb4" onChange={(e) => setRequirementsList({ ...requirementsList, 3: e.target.checked })} />
                                <label className="form-check-label ml-2" htmlFor="cb4" style={{ cursor: "pointer" }}> I have practice experience of at least 3 years</label>
                            </div>
                            <div className="form-check mb-3">
                                <input name="mod5" className="form-check-input" type="checkbox" style={{ width: "1.3rem", height: "1.3rem", cursor: "pointer" }} checked={requirementsList[4]} id="cb5" onChange={(e) => setRequirementsList({ ...requirementsList, 4: e.target.checked })} />
                                <label className="form-check-label ml-2" htmlFor="cb5" style={{ cursor: "pointer" }}> I agree to all <Link to='/termsconditions'><u>Terms &#38; Conditions</u></Link>, <Link to='/privacypolicy'><u>Privacy Policy</u></Link> and <Link to='/cookiepolicy'><u>Cookie Policy</u></Link> of Umang Wellness.</label>
                            </div>
                        </div>


                        <p className='mt-3 mb-0 float-left' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={() => goBack()}><i className="fas fa-arrow-circle-left"></i> Previous</p>
                        <p id="submit-set2" className='mt-3 mb-0 float-right' style={{ fontFamily: fontFamily.primary, color: colors.primary, fontSize: fontSize.lg, cursor: 'pointer' }} onClick={(e) => handleSubmit(e)}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit <i className="fas fa-paper-plane"></i></p>

                    </div>

                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ProviderSignUpStep3;